var deliveryModule = function (_app, _estimateShippmentView, _estimateShippingPostcode, _globalSettings, _eventHandler, forms, _BaseView, _FieldView, shippingInfoPixel) {

    var settings = CheckoutSettings.getBasketSettings();

    var hiddenClass = 'hidden-block';

    _app.activeDeliveryForm = null;

    if (settings.BillingAddressEnabled) {

        var billing = new BillingAddress({
            container: $('@delivery'),
            saved: function (data) {
                model.update(data);
            },
            model: _app.models.delivery.billingAddress
        });

        _app.models.delivery.billingAddress.on('change', function () {
            billing.update(_app.models.delivery.billingAddress);
        });

        _eventHandler.on('display', function (e, form, opts) {
            var hasAddress = billing.hasAddress();
            var display = hasAddress || form === forms.current;
            billing.$el.toggleClass('hidden-block', !display);
        });
    }



    var PickupPointFieldView = Backbone.View.extend({

        errorClass: 'form-field-second__error',

        initialize: function () {
            var postcode_model = this.model.get('Postcode');

            this.$el = $.tmpl('bt-checkout-delivery-pickup-info');

            if (postcode_model) {
                this.$postcode = this.$('@postcode');
                this.$pickupCurrent = this.$('@pickupCurrent');

                this.$pickupPointsContainer = this.$('@pickupPointsContainer');

                this._postcodeView = new _FieldView({ model: postcode_model });
                this.$postcode.html(this._postcodeView.$el);

                this._initPickupPoints();

                this.listenTo(this.model.get('Postcode'), 'change:Value', _.bind(this._getPickupPointsByPostcode, this));

                this.listenTo(this.model, 'change:Selected', _.bind(this._display, this));
                this.listenTo(this.model, 'validation', _.bind(this.validation, this));

                this.listenTo(this.model, 'loading', _.bind(this._toggleSpinner, this));

                this._display();
            }
        },

        _initPickupPoints: function () {
            var settings = CheckoutSettings.getBasketSettings();
            if (!this.pickupPoints) {
                this.pickupPoints = new PickupPointsHelper({
                    /* API Key*/
                    key: settings.PickupPointsMapToken,

                    /* Elements */
                    el: this.$('@pickupPointsContainer')[0],
                    switcher: this.$('@pickupViewModeSwitcher')[0],
                    mapTab: this.$('@pickupViewModeSwitcher-map')[0],
                    listTab: this.$('@pickupViewModeSwitcher-list')[0],
                    mapCanvas: this.$('@pickupPointsMap')[0],
                    pickupListCanvas: this.$('@pickupPointsList')[0],

                    /* Class to hide elements */
                    hiddenClassName: 'hidden-block',

                    displayMap: settings.PickupPointsMapEnabled,

                    /* Default country ID and Zoom settings */
                    countryID: _globalSettings.Iso.toUpperCase(),

                    /* Callback on select PP event */
                    selectCallback: this._selectPickupPoint.bind(this),

                    /* Html Templates */
                    getMarkerInfoHtml: function (data) {
                        return $.tmpl('bt-checkout-delivery-pickup-marker-info', data)[0].outerHTML;
                    },
                    getPickupInfoHtml: function (data) {
                        return $.tmpl('bt-checkout-delivery-pickup', data)[0].outerHTML;
                    },
                    getNoPickupMessageHtml: function () {
                        return $.tmpl('bt-checkout-delivery-pickup-not-found-message')[0].outerHTML;
                    },
                    coordinates_changed: this._getPickupPointsByCoordinates.bind(this)
                });
            }
        },

        _getPickupPointsByCoordinates: function (data) {
            clearTimeout(this.getPpTimeout);
            this.getPpTimeout = setTimeout(function () {
                this.model.loadByCoordinates(data).done(function (pickupPoints) {
                    this.pickupPoints.setPickupPoints(pickupPoints, false);
                }.bind(this));
            }.bind(this), 100);
        },

        _getPickupPointsByPostcode: function (model) {
            if (model.isValid()) {
                var postcode = model.get('Value');
                this.model.loadByPostcode(postcode).done(function (pickupPoints) {
                    this.pickupPoints.setPickupPoints(pickupPoints, true);
                }.bind(this));
            }
        },

        _selectPickupPoint: function (data) {
            _app && _app.event && _app.event.choosePickupPoint();
            this.model.select(data);
        },

        _display: function () {
            this.model.get('Postcode').set('changedByUser', false);
            this.render();
        },

        render: function () {
            if (this.model.get('Selected')) {
                this.$pickupCurrent.html($.tmpl('bt-checkout-delivery-pickup-selected', this.model.get('Selected')));
            }
        },

        _toggleSpinner: function (display) {
            this.spinner = this.spinner || new Spinner(_.extend({}, smallSpinnerConfig.className, { top: '-50px', className: '' }));
            if (display) {
                this.spinner.spin(this.el);
            } else {
                this.spinner.stop();
            }
        },

        validation: function (status) {
            if (status) {
                this.$el.removeClass(this.errorClass);
            } else {
                this.$el.addClass(this.errorClass);
            }
        }
    });

    var SignatureView = Backbone.View.extend({
        initialize: function () {
            _.bindAll(this, 'setInstruction', 'showChange', 'cancel', 'render');

            var instructions = [
                GetPageTemplate('_AuthToLeave_Instruction_1'),
                GetPageTemplate('_AuthToLeave_Instruction_2'),
                GetPageTemplate('_AuthToLeave_Instruction_3'),
                GetPageTemplate('_AuthToLeave_Instruction_4'),
                GetPageTemplate('_AuthToLeave_Instruction_5'),
                GetPageTemplate('_AuthToLeave_Instruction_6')
            ];
            this.$el = $.tmpl('bt-checkout-delivery-sod', { Instruction: instructions });

            this.$sodChange = this.$('@sodChange');
            this.$sodData = this.$('@sodData');
            this.$txtInstruction = this.$('@txtInstruction');
            this.$sodMessage = this.$('@sodMessage');

            this.$sodData.on('click', this.showChange);
            this.$('@allowWithoutSignature').on('click', this.showChange);
            this.$('@btnChangePreference').on('click', this.showChange);
            this.$('@instruction').on('click', this.setInstruction);
            this.$('@sodCancel').on('click', this.cancel);

            this.listenTo(this.model, 'change:AuthComment', this.render);
            this.render();
        },

        render: function () {
            var text = this.model.isAuthComment() ? this.model.getAuthComment() : '';
            this.$sodMessage.text(text ? GetPageTemplate('_NoNeedSoDText') + ' ' + text : GetPageTemplate('_NeedSoDTitle'));
            var textLower = text ? text.toLowerCase() : null;
            _.each(this.$('@instruction'), function (el) {
                var inst = $(el).data('inst').toLowerCase();
                $(el).toggleClass('sod-item-list-option__selected', inst === textLower);
            });
            this.$txtInstruction.off();
            this.$txtInstruction.val(text);
            this.$txtInstruction.on('blur', this.setInstruction);

            this.$sodData.show();

            this.$sodChange.hide();
        },

        showChange: function (e) {
            if (e) e.preventDefault();
            this.$sodData.hide();
            this.$sodChange.show();
        },

        setInstruction: function (e) {
            if (e) e.preventDefault();

            var inst;
            if (e.currentTarget.localName === 'textarea') {
                inst = this.$txtInstruction.val();
            } else {
                inst = $(e.currentTarget).data('inst');
            }

            _app && _app.event && _app.event.chooseSignatureDelivery();

            this.model.applySignature(inst);
            this.render();
        },

        cancel: function (e) {
            e.preventDefault();
            this.model.cancelSignature();
            this.render();
        }
    });

    var NewAddressView = Backbone.View.extend({
        //el: '@newDelivery',
        el: '@newDeliveryContainer',

        events: {
            'click @btnAddAddress': 'addAddress',
            'click @btnChangeTypeOfDelivery': '_back'
        },

        initialize: function () {
            _.bindAll(this);
            this.$fields = this.$('@fields');
            this.$sod = this.$('@sod');
            this.$btnAddAddress = this.$('@btnAddAddress');

            this.fields = {};

            this.collection.on('add', this.render);

            this._updateType();

            _eventHandler.on('display', this.toggle);
            if (this.collection.PickupPointField) {
                this.listenTo(this.collection.PickupPointField, 'change:IsEnabled', this._updateType);
            }

            this._toggleAddButton();
            app.models.page.onAuthChanged(this._toggleAddButton);
            this.collection.on('inProgress', this._inProgress);
        },

        _toggleAddButton: function() {
            //this.$btnAddAddress.toggleClass('hidden-block', !app.models.page.isAuthorized());
        },

        render: function () {
            this.$sod.empty();
            this.collection.each(this.renderField);
            if (this.signature) {
                this.$sod.html(this.signature.$el);
            }
            this._pcaLoad();
        },

        renderField: function (model) {
            var fieldName = model.get('Name');
            var isPpDeliveryType = this.collection.getDeliveryType() === 'PPE';
            var hidden = isPpDeliveryType && !fieldName.match(/^(Name|Phone)$/i);
            model.setHidden(hidden);

            if (fieldName.match(/^(Postcode)$/i)) {
                var postcode = _app.models.delivery.current.get('Postcode');
                if (postcode) {
                    model.setValue(postcode);
                } else if (window.localStorage) {
                    var usepostcode = ((JSON.parse(localStorage.getItem('userPostCode')) || '') + '') || null;
                    usepostcode = usepostcode === 'null' ? null : usepostcode;
                    model.setValue(usepostcode);
                }
            }

            if (!this.fields[fieldName]) {
                this.fields[fieldName] = new _FieldView({ model: model });
                this.$fields.append(this.fields[fieldName].$el);
            }
        },

        toggle: function (e, form, opts) {
            opts = opts || {};

            if (opts.SATL) {
                this.collection.setDeliveryType({ SATL: true });
                this.signature = new SignatureView({ model: this.collection });
            } else {
                this.collection.setDeliveryType({ SATL: false });

                var value = this.collection.getAuthComment();
                this.signature = null;
                if (!value) {
                    this.collection.cancelSignature();
                }
            }

            this._togglePickupPoint(opts.PPE);

            this.render();

            this.collection.setActive(form === forms.add);
            this.$('@newDelivery').toggle(form === forms.add);
            this.$el.toggle(form === forms.add || form === 'pickupDisabled');
        },

        _togglePickupPoint: function (enabled) {
            if (this.collection.PickupPointField) {
                this.pickupInfo = this.pickupInfo || new PickupPointFieldView({ model: this.collection.PickupPointField });

                if (enabled) {
                    var s = this.collection.PickupPointField.get('Selected');
                    var p = this.collection.PickupPointField.get('Postcode').get('Value');

                    this.pickupInfo.validation(true);
                    this.$('@pickupInfo').append(this.pickupInfo.$el);
                    !p && this.pickupInfo.pickupPoints && this.pickupInfo.pickupPoints.clear();
                    !s && this.pickupInfo.$pickupCurrent.html($.tmpl('bt-checkout-delivery-pickup-empty-message'));
                } else {
                    this.pickupInfo.$el.detach();
                }
            }
            this.collection.setDeliveryType({ PPE: enabled });
        },

        addAddress: function (e) {
            e.preventDefault();
            _app && _app.event && _app.event.useThisAddress();

            function handleOnSave(data)
            {
                shippingInfoPixel && shippingInfoPixel.add(data.Value);
            }

            this.collection.save(handleOnSave);
        },

        _pcaLoad: function () {
            var settings = CheckoutSettings.getBasketSettings();

            if (settings.PcaEnabled && !settings.GoogleAddressSuggestionEnabled) {
                var fields = this.collection.filter(function (m) {
                    return m.get('Suggestion');
                }).map(function (m) {
                    var s = m.get('Suggestion');
                    return { element: m.get('Name'), field: s.Field, mode: s.Mode };
                });

                var options = {
                    key: settings.PcaAPIID,
                    search: { countries: _globalSettings.Iso }
                };

                pcaApi.ready(_.bind(function () {
                    this.control = pcaApi.newControl(fields, options, this._pcaAutofill);
                }, this));
            }
        },

        _pcaAutofill: function () {
            setTimeout(_.bind(function () {
                this.collection.pcaUpdateModel();
            }, this), 500);
        },

        _back: function (e) {
            e.preventDefault();
            _eventHandler.trigger('display', forms.chooser);
        },

        _updateType: function () {
            if (this.collection.PickupPointField && this.collection.PickupPointField.isEnabled() && _globalSettings.SATL) {
                this.$el.find('@btnChangeTypeOfDelivery').show();
            } else {
                this.$el.find('@btnChangeTypeOfDelivery').hide();
            }
        },

        _inProgress: function (state) {
            this.$btnAddAddress.toggleClass('checkout-button-add-address', !state);
            this.$btnAddAddress.toggleClass('checkout-button-add-address__processing', state);
        }
    });

    var CurrentAddressView = Backbone.View.extend({
        el: '@lastAddressContainer',
        initialize: function () {
            _.bindAll(this);
            this.$lastAddress = this.$('@lastAddress');

            if (CheckoutSettings.getBasketSettings().PickupPointsEnabled) {
                this.$pickupInfo = $('<div>');
                this.$('@btnChangeAddress').before(this.$pickupInfo);
            }

            this.render();
            _eventHandler.on('display', this.toggle);
            this.model.on('change', this.render);

        },

        render: function () {
            var address = this.model.toJSON();
            var isPickupPoint = this.$pickupInfo && !!this.model.get('PickupPointsEnabled') && !!this.model.get('AdditionalData');

            this.$lastAddress.html($.tmpl('bt-checkout-delivery-address', address));

            if (isPickupPoint) {
                var data = JSON.parse(this.model.get('AdditionalData'));
                data.Recipient = address.Name;
                data.Phone = address.Phone;
                this.$pickupInfo.html($.tmpl('bt-checkout-delivery-pickup-current', data));
            } else if (_globalSettings.SATL) {
                var signature = new SignatureView({ model: this.model });
                this.$lastAddress.append(signature.$el);
            }

            this.$lastAddress && this.$lastAddress.toggle(!isPickupPoint);
            this.$pickupInfo && this.$pickupInfo.toggle(isPickupPoint);
        },
        toggle: function (e, form) {
            if (form != forms.current) {
                this.model.clear();
            }
            this.model.setActive(form == forms.current);
            this.$el.toggle(form == forms.current);
        },
        cancelSod: function () {
            this.model.cancelSod();
        },
        changeInstruction: function (text) {
            this.model.applySod(text);
        }
    });


    var AddressView = Backbone.View.extend({
        className: 'clearfix list-row list-row-hover list-row__full',
        events: {
            'click': 'choose'
        },
        initialize: function () {
            _.bindAll(this);
            this.model.on('remove', this.remove);
            this.model.on('change', this.render);
            this.render();
        },
        render: function () {
            var hasLinkedAddress = !!this.model.get('LinkedAddress');
            this.$el.html($.tmpl('bt-checkout-delivery-address', this.model.toJSON()));
            if (_globalSettings.SATL && this.model.get('AuthToLeave')) {
                this.$('@sod').show();
            }
            this.$('@address').toggle(!hasLinkedAddress);
            this.$('@pickup').toggle(hasLinkedAddress);
        },
        choose: function () {
            this.model.select();
        }
    });

    var AddressesListView = Backbone.View.extend({
        el: '@addressListContainer',
        initialize: function () {
            _.bindAll(this);
            this.$addressList = this.$('@addressList');

            _eventHandler.on('display', this.toggle);
            this.collection.on('add', this.render);
        },
        render: function (model) {
            this.$addressList.append(new AddressView({ model: model }).$el);
        },
        toggle: function (e, form) {
            this.collection.setActive(form == forms.list);
            this.$el.toggle(form == forms.list);
        }
    });


    var _estimateShippment = new _estimateShippmentView({ model: _app.models.summary });
    _estimateShippment.$el.insertBefore('@lastAddressContainer');


    var currentAddress = new CurrentAddressView({ model: _app.models.delivery.current });

    var newAddress = new NewAddressView({ collection: _app.models.delivery.decoration });

    var addressList = new AddressesListView({ collection: _app.models.delivery.addressesList });

    var _q = new (Backbone.View.extend({
        el: '@newDeliveryChooser',

        events: {
            'click @choosePL': '_choosePL',
            'click @chooseDA': '_chooseDA'
        },

        initialize: function () {
            _.bindAll(this, 'toggle');
            this.$choosePL = this.$('@choosePL');
            this.$chooseDA = this.$('@chooseDA');
            this.$deliveryChooserDescription = this.$('@deliveryChooserDescription');
            this.$deliveryChooserDescription.text(GetPageTemplate('_deliveryAddressDescription'));
            _eventHandler.on('display', this.toggle);
        },

        toggle: function (e, form, opts) {
            var s = this._getPpSettings();
            this.$el.toggle(s.isPPEnabled && (form === forms.add || form === 'pickupDisabled'));
            if (form === forms.add || form === 'pickupDisabled') {
                this.$choosePL.toggleClass('delivery-chooser__active', opts && opts.PPE === 1);
                this.$chooseDA.toggleClass('delivery-chooser__active', opts && opts.PPE !== 1);
            }
        },

        _choosePL: function () {
            var s = this._getPpSettings();
            if (s.isPPAvailable) {
                _app && _app.event && _app.event.chooseAddressTypePickupPoint();
                this.$deliveryChooserDescription.text(GetPageTemplate('_pickupPointDescription'));
                api.sendPPAddressSelectedEvent();
                _eventHandler.trigger('display', [forms.add, { PPE: 1 }]);
            } else {
                this.$deliveryChooserDescription.text(GetPageTemplate('_pickupPointDescriptionUnavailable'));
                _eventHandler.trigger('display', ['pickupDisabled']);
            }
        },

        _chooseDA: function () {
            _app && _app.event && _app.event.chooseAddressTypeSimple();

            this.$deliveryChooserDescription.text(GetPageTemplate('_deliveryAddressDescription'));
            _eventHandler.trigger('display', [forms.add, { SATL: _globalSettings.SATL && 1 }]);
        },
        _getPpSettings: function () {
            var settings = CheckoutSettings.getBasketSettings();

            return {
                isPPAvailable: _app.models.delivery.current.get('PickupPointsEnabled'),
                isPPEnabled: settings.PickupPointsEnabled
            }
        }
    }))();

    var DeliveryView = _BaseView.extend({
        el: '@delivery',

        events: {
            'click @btnChangeAddress': '_changeAddress',
            'click @btnAddAddressForm': 'showNewAddressForm',
            'click @btnUseAnotherAddress': '_showAddressesList'
        },

        initialize: function () {
            _.bindAll(this);

            this.isAuth = this._isAuth();

            this.onChangeDeliverySectionMode(this._switchFormMode);
            this._switchFormMode();

            if (!this.settings('GiftEnabled')) {
                $('@GiftBasketBtn').remove();
            } else {
                $('@GiftBasketBtn').on('click', this._switchToGiftMode);
            }

            this.$btnUseAnotherAddress = this.$('@btnUseAnotherAddress');
            this.render();
            _app.models.delivery.current.on('change:ID', this.render);
            var pickupPoint = this._getPickupPoint();
            pickupPoint && pickupPoint.on('change:IsEnabled', this.render);
        },

        _switchFormMode: function (e, mode) {
            mode = mode || this.getDeliverySectionMode();
            this.$el.toggleClass(hiddenClass, mode !== this.deliverySectionMode.general);
            $('@GiftBasketBtn').toggleClass(hiddenClass, mode !== this.deliverySectionMode.general);
        },

        _switchToGiftMode: function () {
            $('@GiftBasketBtn').addClass('checkout-button-delivery-address-mode__processing');
            app.checkout.switchBasketMode(this.deliverySectionMode.gift)
                .always(_.bind(function () {
                    $('@GiftBasketBtn').removeClass('checkout-button-delivery-address-mode__processing');
                }, this));
        },

        render: function () {
            if (_app.models.page.get('IsEmpty') === true) return;

            if (this.isAuth !== this._isAuth()) {
                this.isAuth = this._isAuth();

                if (_app.models.delivery.current.id) {
                    this.$btnUseAnotherAddress.show();
                }

                return;
            }

            if (_app.models.delivery.current.id) {
                this.$btnUseAnotherAddress.show();
                _eventHandler.trigger('display', forms.current);
            } else {
                this.$btnUseAnotherAddress.hide();
                this.showNewAddressForm();
            }
        },

        _isAuth: function() {
            return !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
        },

        _changeAddress: function (e) {
            e.preventDefault();
            _app && _app.event && _app.event.changeAddress();
            if (!IsAuthorized()) {
                this.showNewAddressForm();
            } else {
                var addressesCount = _app.models.delivery.current.isPickupPoint() ? 1 : 2;

                this._getAddressList(function (addresses) {
                    if (!addresses || addresses.length < addressesCount) {
                        this.showNewAddressForm();
                    } else {
                        _eventHandler.trigger('display', forms.list);
                    }
                });
            }
        },

        _showAddressesList: function (e) {
            e.preventDefault();
            _app && _app.event && _app.event.useAnotherAddress();
            if (!IsAuthorized()) {
                _eventHandler.trigger('display', forms.current);
            } else {
                this._getAddressList(function (addresses) {
                    if (!addresses || addresses.length < 2) {
                        _eventHandler.trigger('display', forms.current);
                    } else {
                        _eventHandler.trigger('display', forms.list);
                    }
                });
            }
        },

        _getAddressList: function (callback) {
            _app.models.delivery.addressesList.fetch().done(_.bind(callback, this));
        },

        showNewAddressForm: function (e) {
            e && e.preventDefault();
            _eventHandler.trigger('display', [forms.add, { SATL: _globalSettings.SATL && 1 }]);
        },
        _getPickupPoint: function () {
            return _app.models.delivery.current.PickupPointField;
        },
        _isPickupPointEnabledInCountry: function () {
            var settings = CheckoutSettings.getBasketSettings();
            return settings.PickupPointsEnabled;
        }
    });

    var DeliveryFeeHandler = function (models, summary) {
        var _settings = CheckoutSettings.getBasketSettings();
        var _currentPostcode;
        var _currentPP;

        var _postcodeFieldModel;
        var _pickupPointModel = models.decoration.PickupPointField;

        var hasPostcode = !!models.decoration.where({ Name: 'Postcode' }).length;

        if (!_settings || _settings.ShippingByPostcodeEnabled !== true || !hasPostcode) {
            return;
        }

        var _setPostcode = function (postcode, pickupPoint) {
            if (app.models.page.get('BasketMode') !== 0) return;

            if (postcode === null) {
                _currentPostcode = null;
                _currentPP = null;
                return;
            }

            var submit = false;
            var pp = "";

            if (pickupPoint && (!_currentPP || _currentPP.Postcode != pickupPoint.Postcode && _currentPP.PostServiceId != pickupPoint.PostServiceId)) {
                _currentPostcode = null;
                _currentPP = pickupPoint;
                submit = true;
                pp = JSON.stringify(pickupPoint);
            }

            if (!pickupPoint) {
                submit = _currentPostcode != postcode;
                _currentPostcode = postcode;
                _currentPP = null;
            }

            _estimateShippingPostcode.set(postcode);
            if (submit && _estimateShippingPostcode.hasAddress() !== true) {

                //$('@estimateSubmint').addClass('estimete-shipping-form-button__processing');
                $('@estimateSubmint').trigger('inprogress', true);
                api.getPrices({
                    Postcode: postcode,
                    PickupPoint: pp
                }).done(function (data) {
                    if (data && data.Value) {
                        _app.checkout._update(data);
                    }
                }).always(function () {
                    $('@estimateSubmint').trigger('inprogress', false);
                    //$('@estimateSubmint').removeClass('estimete-shipping-form-button__processing');
                });
            }
        }

        var _getPPData = function (selected) {
            if (selected && selected.ID) {
                return {
                    Postcode: selected.Postcode,
                    PostServiceId: selected.PostServiceId
                };
            }
            return null;
        }

        /* Subscribe on select delivery address from address list */
        models.addressesList.on('Select', function (address) {
            var additionalData = address.AdditionalData;
            if (!additionalData) {
                _currentPostcode = address.Postcode;
                _currentPP = null;
            }
            else if (additionalData) {
                var data = _getPPData(JSON.parse(additionalData));
                if (data) {
                    _currentPostcode = null;
                    _currentPP = data;
                }
            }
        });

        /* Subscribe on update new delivery address postcode */
        models.decoration.each(function (model) {
            var name = model.get('Name');
            if (name.match(/^(Postcode)$/i)) {
                _postcodeFieldModel = model;
                model.on('valueChanged', function (field) {
                    if (field.isValid === true) {
                        _setPostcode(field.value);
                    }
                });
            }
        });

        /* Subscribe on PP update */
        _pickupPointModel.on('change:Selected', function (model) {
            var selected = model.get('Selected');
            var data = _getPPData(selected);
            data && _setPostcode(data.Postcode, data);
        });

        /* Subscribe on switch between forms*/
        _eventHandler.on('display', function (e, form, opts) {
            
            if (form === forms.current) {
                var additionalData = models.current.get('AdditionalData');
                if (additionalData) {
                    var data = _getPPData(additionalData);
                    data && _setPostcode(data.Postcode, data);
                } else {
                    var postcode = models.current.get('Postcode');
                    _setPostcode(postcode);
                }
            }

            _estimateShippingPostcode.hasAddress(form == forms.current);

            if (form === forms.add && !opts.PPE) {
                if (_postcodeFieldModel && _postcodeFieldModel.checkValid()) {
                    _setPostcode(_postcodeFieldModel.get('Value'));
                }
            }

            if (form === forms.add && opts.PPE) {
                var selected = _pickupPointModel.get('Selected');
                var data = _getPPData(selected);
                data && _setPostcode(data.Postcode, data);
            }
        });

    }(_app.models.delivery, _app.models.summary);

    new DeliveryView();
};